import { CssType, ThemeType } from "src/theme/jss-types";

export const EditPieceDetailsSideDrawerStyles = (theme: ThemeType): CssType => ({
    justifyContent: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    closeButton: {
        fontSize: '24px',
        color: '#111111',
        cursor: 'pointer',
        marginRight: '12px',
    },
    cancelButton: {
        color: '#111111',
        fontSize: '12px',
        cursor: 'pointer',
        marginRight: '20px',
    },
    updateButtonDisabled: {
        color: '#FFFFFF !important',
        background: '#CCCCCC !important',
        border: '1px solid #CCCCCC !important',
        borderRadius: '4px !important',
        padding: '0px 12px',
        cursor: 'not-allowed',
        '&:hover': {
            color: '#FFFFFF !important',
            background: '#CCCCCC !important',
            border: '1px solid #CCCCCC !important',
            borderRadius: '4px !important',
        },
        '&:focus': {
            color: '#FFFFFF !important',
            background: '#CCCCCC !important',
            border: '1px solid #CCCCCC !important',
            borderRadius: '4px !important',
        },
    },
    updateButton: {
        color: '#FFFFFF !important',
        background: '#1659CB !important',
        border: '1px solid #1659CB !important',
        borderRadius: '4px !important',
        padding: '0px 12px',
        '&:hover': {
            color: '#FFFFFF !important',
            background: '#1659CB !important',
            border: '1px solid #1659CB !important',
        },
        '&:focus': {
            color: '#FFFFFF !important',
            background: '#1659CB !important',
            border: '1px solid #1659CB !important',
        },
    },
    uploadIcon: {
        color: '#1659CB !important',
        borderRadius: '4px',
        border: '1px solid #1659CB',
        fontSize: '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '26px',
        width: '26px',
        cursor: 'pointer',
    },
    uploadIconDisabled: {
        color: '#CCCCCC !important',
        borderRadius: '4px',
        border: '1px solid #CCCCCC',
        fontSize: '16px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '26px',
        width: '26px',
        cursor: 'not-allowed !important',
        backgroundColor: '#f5f5f5',
    },
    bulkActionsButton: {
        color: '#1659CB !important',
        background: '#FFFFFF !important',
        border: '1px solid #1659CB !important',
        borderRadius: '4px !important',
        padding: '0px 12px',
        '&:hover': {
            color: '#1659CB !important',
            background: '#FFFFFF !important',
            border: '1px solid #1659CB !important',
        },
        '&:focus': {
            color: '#1659CB !important',
            background: '#FFFFFF !important',
            border: '1px solid #1659CB !important',
        },
    },
    dateSelect: {
        width: '60%',
        '& .ant-picker': {
            borderRight: '0 !important',
        },
    },
    timeSelect: {
        width: '40%',
    },
    tableParent: {
        margin: '8px',
        '& .ant-table-tbody > tr > td': {
            wordWrap: 'break-word',
            wordBreak: 'break-all',
            '& a': {
                color: '#1659CB',
            },
        },
        '& .ant-table-container table > thead > tr:first-child th:first-child': {
            borderLeft: '0.5px solid #DDD',
            padding: 0,
        },
        '& .ant-table-thead': {
            color: '#333333',
        },
        '& .ant-table-thead > tr > th': {
            wordBreak: 'break-word',
            backgroundColor: '#F2F7FC',
            color: '#333333',
            overflow: 'hidden',
            fontSize: '12px',
            fontWeight: '600',
            lineHeight: '12px',
            padding: '16px',
            borderRight: '0.5px solid #DDD',
            '& .ant-table-column-title': {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                width: '100%',
            },
        },
        '& .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before': {
            backgroundColor: 'unset',
        },
        '& .ant-table-row > td': {
            fontSize: '12px',
            lineHeight: '14px',
            padding: '10px 12px',
            color: '#333333',
            fontWeight: '500',
            borderRight: '0.5px solid #DDD',
        },
        '& .ant-table-row > td:first-child': {
            borderLeft: '0.5px solid #DDD',
            padding: 0,
        },
        '& .ant-table-row-selected > td': {
            backgroundColor: `#E6F7FB !important`, // Solid color without opacity to prevent stacking issues with fixed columns
        },
    },
    statusDropdownContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    requiredAsterisk: {
        color: 'red',
        marginLeft: 4,
    },
    reasonSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: '#F9FAFB',
        padding: '8px 12px',
        borderRadius: '6px',
        border: '1px solid #E5E7EB',
        width: '380px',
    },
    reasonDropdownContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        marginRight: '8px',
    },
    commentContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    reasonLabel: {
        fontSize: 12,
        fontWeight: 500,
        color: '#374151',
        marginBottom: 4,
    },
});
